import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/back_to_top.svg';
const BackToTopSvg = () => React.createElement(IconSvg, null);
BackToTopSvg.Enhance = () => React.createElement(IconSvg, null);
export default BackToTopSvg;
